export default [
    {
        "id": 1,
        "createdAt": "2023-09-23T22:43:11.566Z",
        "updatedAt": "2024-05-01T13:09:24.919Z",
        "description": "enableLeaderboard",
        "status": false,
        "value": null,
        "text": null,
        "date": null
    },
    {
        "id": 2,
        "createdAt": "2023-09-23T22:43:11.566Z",
        "updatedAt": "2024-04-30T22:02:07.305Z",
        "description": "enableRaffles",
        "status": false,
        "value": null,
        "text": null,
        "date": null
    },
    {
        "id": 3,
        "createdAt": "2023-09-23T22:43:11.566Z",
        "updatedAt": "2024-04-24T20:43:27.906Z",
        "description": "enableTeamChanges",
        "status": true,
        "value": null,
        "text": null,
        "date": null
    },
    {
        "id": 6,
        "createdAt": "2023-09-23T22:43:11.566Z",
        "updatedAt": "2024-04-30T21:04:28.916Z",
        "description": "enableAuctionItems",
        "status": false,
        "value": null,
        "text": null,
        "date": null
    },
    {
        "id": 4,
        "createdAt": "2023-09-23T22:43:11.566Z",
        "updatedAt": "2025-04-07T19:57:43.622Z",
        "description": "selectYear",
        "status": true,
        "value": 2025,
        "text": null,
        "date": null
    },
    {
        "id": 5,
        "createdAt": "2023-09-23T22:43:11.566Z",
        "updatedAt": "2025-04-07T19:57:46.144Z",
        "description": "currentYear",
        "status": true,
        "value": 2025,
        "text": null,
        "date": null
    }
];